"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setConfig = setConfig;
exports.getConfig = getConfig;

require("core-js/modules/es6.object.assign");

// 配置
var options = {};

function setConfig(opts) {
  Object.assign(options, opts);
  return this;
}

function getConfig() {
  return options;
}